var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"link",on:{"click":_vm.toggleDropdown}},[_vm._t("link")],2),_c('transition',{attrs:{"name":"modalfadein","mode":"in-out"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"dropdown"},[_vm._t("content")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }